import { render, staticRenderFns } from "./OverviewFuel.vue?vue&type=template&id=389f7ebf"
import script from "./OverviewFuel.vue?vue&type=script&lang=js"
export * from "./OverviewFuel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports